import React, { useContext, useState, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { StepContainer, TagSetupMethodView } from '@bingads-webui-campaign-react/goal-creation-wizard';
import { UetSetupWizardContext } from '../../uet-setup-wizard-context';
import { WIZARD_ACTIONS } from '../../uet-setup-wizard-reducer';

const TagSetupMethodStepUnwrapped = (props) => {
  const {
    selectedItem,
  } = props;
  const wizardContext = useContext(UetSetupWizardContext);
  const { logActivity, permissions, scope } = wizardContext;
  const [selectedTagSetupMethod, setSelectedTagSetupMethod] = useState(selectedItem);
  const i18n = useContext(I18nContext);

  const handleNext = useCallback(() => {
    logActivity.trace(`[TagSetupMethod] Selected tag setup method: ${selectedTagSetupMethod}`);
    wizardContext.dispatch({
      type: WIZARD_ACTIONS.SELECT_TAG_SETUP_METHOD,
      data: { selectedTagSetupMethod },
    });
  }, [logActivity, wizardContext, selectedTagSetupMethod]);

  const updateTagSetupMethod = (option) => {
    setSelectedTagSetupMethod(option);
  };

  const handleCancel = useCallback(() => {
    wizardContext.exitWizard();
  }, [wizardContext]);

  const footerConfig = useMemo(() => ({
    buttons: [{
      type: 'Secondary',
      onClick: wizardContext.goBack,
      isEnabled: true,
      text: i18n.getString(_TL_(('Back'))),
    },
    {
      type: 'Primary',
      onClick: handleNext,
      isEnabled: !!selectedTagSetupMethod,
      text: i18n.getString(_TL_(('Next'))),
    },
    {
      type: 'Cancel',
      onClick: handleCancel,
      isEnabled: true,
      text: i18n.getString(_TL_(('Cancel'))),
    }],
  }), [wizardContext.goBack, handleCancel, handleNext, selectedTagSetupMethod, i18n]);

  return (
    <StepContainer
      step="tag-setup-selection"
      footerConfig={footerConfig}
      title={i18n.getString(_TL_('Set up tagging'))}
    >
      <TagSetupMethodView
        selectedItem={selectedTagSetupMethod}
        i18n={i18n}
        scope={scope}
        permissions={permissions}
        updateTagSetupMethod={updateTagSetupMethod}
        logActivity={logActivity}
      />
    </StepContainer>
  );
};

TagSetupMethodStepUnwrapped.propTypes = {
  selectedItem: PropTypes.string,
};

TagSetupMethodStepUnwrapped.defaultProps = {
  selectedItem: null,
};

export const TagSetupMethodStep = TagSetupMethodStepUnwrapped;
